import React from 'react';
import { PortfolioDetailsInvestorItem } from '../../models/Portfolio';
import { Avatar, Box, ITheme, SvgIcon, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {ReactComponent as mailIcon} from '../../assets/mail.svg';
import {ReactComponent as phoneIcon} from '../../assets/phone.svg';
import {ReactComponent as localisationIcon} from '../../assets/localisation.svg';

export interface IInvestorsListItemProps{
    investor: PortfolioDetailsInvestorItem;
    color: string;
}

const stringAvatar = (name: string, color: string) => {
    return {
      sx: {
        width: 87,
        height: 87,
        backgroundColor: color
      },
      children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
  }

const InvestorsListItem: React.FC<IInvestorsListItemProps> = ({ investor, color }) => {
    const theme = useTheme() as ITheme;
    const { i18n } = useTranslation();

    return <Box display="flex" flexDirection={"column"} alignItems={"center"} width={"240px"} borderRadius={"8px"} bgcolor={theme.palette.common.white} sx={{ boxShadow: "0px 2px 16px 0px #0000000F"}} gap={"24px"} padding={"13px"}>
        <Avatar {...stringAvatar(`${investor.name} ${investor.surname}`, color)} />
        <Typography fontSize={"20px"} lineHeight={"24.38px"} fontWeight={"600"} textAlign={"center"} color={theme.palette.primary.dark}>{investor.name} {investor.surname}</Typography>
        <Typography fontSize={"20px"} lineHeight={"20px"} fontWeight={"400"} textAlign={"center"} color={theme.palette.leo.primary.blue[200]}>€{investor.amount.toLocaleString(i18n.language)}</Typography>
        <Box width={"100%"} display={"flex"} padding={"0 10px"} gap={"12px"}>
            <SvgIcon component={mailIcon} inheritViewBox style={{ width: "20px", height: "20px", color: theme.palette.primary.dark}}/>
            <Typography fontSize={"14px"} lineHeight={"20px"} fontWeight={"400"}>{investor.email}</Typography>
        </Box>
        <Box width={"100%"} display={"flex"} padding={"0 10px"} gap={"12px"}>
            <SvgIcon component={phoneIcon} inheritViewBox style={{ width: "20px", height: "20px", color: theme.palette.primary.dark }} />
            <Typography fontSize={"14px"} lineHeight={"20px"} fontWeight={"400"}>{investor.phone}</Typography>
        </Box>
        <Box width={"100%"} display={"flex"} padding={"0 10px"} gap={"12px"}>
            <SvgIcon component={localisationIcon} inheritViewBox style={{ width: "20px", height: "20px", color: theme.palette.primary.dark }} />
            <Typography fontSize={"14px"} lineHeight={"20px"} fontWeight={"400"}>{investor.city}, {investor.country}</Typography>
        </Box>
    </Box>;
}

export default InvestorsListItem;